module.exports = __webpack_public_path__ + "static/media/md-arrow-dropup.bd452c7b.svg";